import script from "./HotelOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./HotelOrders.vue?vue&type=script&setup=true&lang=js"

import "./HotelOrders.vue?vue&type=style&index=0&id=00b02a9a&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00b02a9a"]])

export default __exports__